import { getOnPremServerUrl } from '@/tauri/onprem/serverConfig';
import { isTauri } from '@/tauri/utils';
import { isOnPrem } from '@/utils/buildProfile';
import { ENV_NAME, getEnvironment } from '@heidi/api/config';

/**
 * Hosted Scribe-FE origin per build environment, used when the Tauri webview
 * origin cannot anchor a real URL.
 */
export function getHostedWebAppOrigin(): string {
  switch (getEnvironment()) {
    case ENV_NAME.PROD:
      return 'https://scribe.heidihealth.com';
    case ENV_NAME.STAGING:
      return 'https://registrar.scribe.heidihealth.com';
    case ENV_NAME.LOCALHOST:
      return 'http://localhost:3000';
    case ENV_NAME.DEV:
    case ENV_NAME.AZURE_DEV:
    default:
      return 'https://scribe.dev.heidihealth.com';
  }
}

function getOnPremShareOrigin(): string {
  const stored = getOnPremServerUrl();
  if (stored) {
    try {
      return new URL(stored).origin;
    } catch {
      // fall through to the webview origin
    }
  }
  return window.location.origin;
}

export function getWebAppOrigin(): string {
  if (typeof window === 'undefined') return '';
  if (!isTauri()) return window.location.origin;
  if (isOnPrem) return getOnPremShareOrigin();
  if (getEnvironment() === ENV_NAME.LOCALHOST) return window.location.origin;
  return getHostedWebAppOrigin();
}
